import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {GetExamsCities, GetExamsCitiesParams, GetExamsCitiesModel} from 'domain/usecases';

export class RemoteGetExamsCities implements GetExamsCities {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetExamsCitiesModel>,
	) {}

	async get({signal, ...params}: GetExamsCitiesParams): Promise<GetExamsCitiesModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
